import { WorkStationTypeEnum } from "@gtpl/shared-models/common-models";
import { GradingModel } from "./gradings.model";

export class GradeReportingRequest {
    shift: string;
    plantId: number;
    lotNo: string;
    workstationType: WorkStationTypeEnum;
    workstation: number;
    grades: GradingModel[];
    soNumber:string;
    createdUser: string;

    constructor(shift: string,plantId: number,lotNo: string,workstationType: WorkStationTypeEnum,workstation: number,grades: GradingModel[],soNumber:string,createdUser: string){
        this.shift = shift;
        this.plantId = plantId;
        this.lotNo = lotNo;
        this.workstationType = workstationType;
        this.workstation = workstation;
        this.grades = grades;
        this.soNumber= soNumber;
        this.createdUser = createdUser;
    }

}